import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Modals {
  stack: string[];
}

export const modalsSlice = createSlice({
  name: "modals",
  initialState: {
    stack: [],
  } as Modals,
  reducers: {
    addToStack: (
      state,
      action: PayloadAction<{
        modalId: string;
      }>,
    ) => {
      state.stack = [...state.stack, action.payload.modalId];
    },
    removeFromStack: (
      state,
      action: PayloadAction<{
        modalId: string;
      }>,
    ) => {
      state.stack = state.stack.filter(
        (modalId) => modalId !== action.payload.modalId,
      );
    },
  },
});

export const { addToStack, removeFromStack } = modalsSlice.actions;

export default modalsSlice.reducer;
